// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-theme .special_sjqx[data-v-2073b1ad] .el-form-item, .special_sjqx[data-v-2073b1ad] .el-form-item {\n  margin-bottom: 10px !important;\n  margin-top: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
